export default __webpack_public_path__ + "static/media/menu-collapse-white.98e23359.svg";